// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".src-features-license-styles-___LicenseControls__LicenseControls___IbO0q{background:#efefef;padding:8px}.src-features-license-styles-___LicenseControls__LicenseControls___IbO0q .src-features-license-styles-___LicenseControls__padder___3H_dW{height:8px;width:8px}.src-features-license-styles-___LicenseControls__LicenseControls___IbO0q .src-features-license-styles-___LicenseControls__controls___1pkwX{display:flex}\n", ""]);
// Exports
exports.locals = {
	"LicenseControls": "src-features-license-styles-___LicenseControls__LicenseControls___IbO0q",
	"padder": "src-features-license-styles-___LicenseControls__padder___3H_dW",
	"controls": "src-features-license-styles-___LicenseControls__controls___1pkwX"
};
module.exports = exports;
